import React, { useState } from "react";
import { Search as SearchIcon } from "@mui/icons-material";

const SearchComponent = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    onSearch(e.target.value);
  };

  return (
    <div className="flex items-center bg-gray-100 rounded-md px-3 py-2">
      <SearchIcon className="text-gray-500 mr-2" />
      <input
        type="text"
        placeholder="Search..."
        value={searchTerm}
        onChange={handleInputChange}
        className="bg-transparent outline-none flex-1"
      />
    </div>
  );
};

export default SearchComponent;
